import { Translate } from "../../../hooks/useTranslation";

export const NoData = () => (
    <div className="min-h-[50px] p-4 pl-0 font-medium">
        <Translate>Data isn't currently available</Translate>
    </div>
);
